import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { WaIntersectionObserver } from '@ng-web-apis/intersection-observer';
import { FitType } from '../fit-type';
import { CtDocument, CtPage } from '../../model/ct-batch-model';
import { PageImageService } from '../../batch-api/page-image.service';
import { ProgressSpinner } from 'primeng/progressspinner';

export type PageIntersectionEvent = Pick<IntersectionObserverEntry, 'isIntersecting' | 'target'>;

@Component({
  selector: 'ct-shared-document-page-preview',
  imports: [WaIntersectionObserver, ProgressSpinner],
  templateUrl: './document-page-preview.component.html',
  styleUrl: './document-page-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPagePreviewComponent {
  readonly document = input.required<CtDocument>();
  readonly page = input.required<CtPage>();
  readonly fitType = input.required<FitType>();
  readonly zoom = input.required<number>();

  readonly pageId = computed(() => this.page().id);

  pageIntersection = output<PageIntersectionEvent>();

  protected readonly pageImageService = inject(PageImageService);

  protected getImageSrc(): string | undefined {
    return this.pageImageService.getImageSrc(this.pageId())();
  }

  protected isImageLoaded() {
    return this.pageImageService.isImageLoaded(this.pageId())();
  }

  onImageLoaded(image: HTMLImageElement) {
    this.pageImageService.updateImageAspectRatio(
      this.pageId(),
      image.naturalWidth / image.naturalHeight,
    );
  }

  protected onIntersectionDetected($event: IntersectionObserverEntry[]) {
    this.pageIntersection.emit({
      isIntersecting: $event[0].isIntersecting,
      target: $event[0].target,
    });
  }
}
